import { ACTIONS } from "app/store/actions"
import { IAppMessageState } from "message/model"
import { Action, Reducer } from "redux"
import {
  IMessageActionAddMessage,
  IMessageActionAddOverlayMessage,
  IMessageActionDeleteMessage,
  IMessageActionDeleteOverlayMessages,
  IMessageActionSetConfirmMessage
} from "./action"
import { getDefaultMessageState } from "./state"

const MAX_MESSAGE_QUEUE_LENGTH = 740

export const messageReducer: Reducer<IAppMessageState, Action> = (
  state: IAppMessageState | undefined,
  action: Action
): IAppMessageState => {
  if (!state) {
    state = getDefaultMessageState()
  }
  switch (action.type) {
    case ACTIONS.APP_MESSAGE_ADD_MESSAGE: {
      const { message } = action as IMessageActionAddMessage
      const newMessages = [...state.messages, message]
      while (newMessages.length > MAX_MESSAGE_QUEUE_LENGTH) {
        newMessages.shift()
      }
      return { ...state, messages: newMessages }
    }

    case ACTIONS.APP_MESSAGE_DELETE: {
      const { messageId } = action as IMessageActionDeleteMessage
      return { ...state, messages: state.messages.filter(m => m.id !== messageId) }
    }

    case ACTIONS.APP_MESSAGE_SET_CONFIRM_MESSAGE: {
      const { confirmMessage } = action as IMessageActionSetConfirmMessage
      return { ...state, confirmMessage }
    }

    case ACTIONS.APP_MESSAGE_ADD_OVERLAY_MESSAGE: {
      const { message } = action as IMessageActionAddOverlayMessage
      return { ...state, overlayMessages: [...state.overlayMessages, message] }
    }

    case ACTIONS.APP_MESSAGE_DELETE_OVERLAY_MESSAGES: {
      const { messageIds } = action as IMessageActionDeleteOverlayMessages
      return {
        ...state,
        overlayMessages: [...state.overlayMessages.filter(message => !messageIds.includes(message.id))]
      }
    }

    default:
      return state
  }
}
